// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header_app {
  background-color: #6C6BAE;
  min-height: 13vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2.8vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: white;
}

.body_app {
  background-color: #000000;
  height: 75vh;
  display: flex;
  flex-direction: row;
  /* align-items: center;
  justify-content: center; */
  color: white;
}

.body_left_app {
  position: relative;
  background-color: #ffffff;
  min-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
}

.logo_box_app {
  position: absolute;
  top: 10%;
  left: 0%;
  background-color: #ffffff;
  width: 50%;
  height: 60%;
}

.body_left_head_app {
  /* position: absolute;
  top: 0%;
  left: 0%; */
  background-color: #F3F7F9;
  min-width: 50vw;
  min-height:6vh;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.body_left_right_app {
  position: absolute;
  background-color: #ffffff;
  top: 10%;
  left: 50%;
  width: 50%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  padding-left: 5%;
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.Available_box {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 22%;
  left: 5%;
  width: 10vw;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.Unvailable_box {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 44%;
  left: 5%;
  width: 10vw;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.Time_box {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 68%;
  left: 5%;
  width: 20vw;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  font-size: 1vw;
  font-family: 'Roboto', sans-serif;
  font-weight: lighter;
  color: #2F343B;
}

/* .login_box {
  position: absolute;
  background-color: #ffffff;
  top: 75%;
  left: 40%;
  width: 20%;
  height: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.4vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
  border: 0.1vw solid #646464;
  border-radius: 2vw;
} */

.login_box_new {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 93%;
  left: 40%;
  width: 10vw;
  height: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 1vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.red_box {
  position: absolute;
  background-color: rgb(255, 0, 0);
  top: 44%;
  left: 55%;
  width: 18%;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #ffffff;
}

.green_box_app {
  position: absolute;
  background-color: green;
  top: 22%;
  left: 55%;
  width: 18%;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #ffffff;
}

.body_right {
  position: relative; /* เมื่อกล่องใช้ absulote จะอ้างอิงตำแหน่งจาก div นี้แทน */
  background-color: #80e588;
  min-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2vw;
  color: white;
}

.footer_app {
  background-color: #2F343B;
  height: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1vw;
  color: white;
}

.box_row_1_1 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_1_2 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_1_3 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_1_4 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_2_1 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_2_2 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_2_3 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_2_4 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_3_1 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_3_2 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_3_3 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_3_4 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_4_1 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 40%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_4_2 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 46%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_4_3 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 52%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_4_4 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 58%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.box_row_4_5 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 64%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

html, body {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

@media (max-width: 768px) {
  .body_app {
    background-color: #000000;
    flex-grow: 1;
    height: auto !important;
    /* min-height: vh; */
    display: flex;
    flex-direction: column !important;
  }

  .body_left_app {
    width: 100% ;
    height: 40vh ;
    /* min-height: 45vh ; */
    position: relative;
  }

  .body_right {
    width: 100% ;
    height: 50vh ;
    /* min-height: 40vh ; */
    position: relative;
  }

  .logo_box_app {
    position: absolute;
    top: 13%;
    left: 0%;
    background-color: #ffffff;
    width: 50%;
    height: 80%;
  }

  .body_left_right_app {
    position: absolute;
    background-color: #ffffff;
    top: 13%;
    left: 50%;
    width: 50vw;
    height: 35vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    padding-left: 5%;
    font-size: 2vw;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #2F343B;
  }

  .Available_box {
    position: absolute;
    background-color: rgb(255, 255, 255);
    top: 22%;
    left: 5%;
    width: 10vw;
    height: 18%;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #2F343B;
  }

  .Unvailable_box {
    position: absolute;
    background-color: rgb(255, 255, 255);
    top: 44%;
    left: 5%;
    width: 10vw;
    height: 18%;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #2F343B;
  }

  .Time_box {
    position: absolute;
    background-color: rgb(255, 255, 255);
    top: 68%;
    left: 5%;
    width: 30vh;
    height: 18%;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* ตำแหน่งแนวนอน */
    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
    font-size: 1.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: lighter;
    color: #2F343B;
  }

  .red_box {
    position: absolute;
    background-color: rgb(255, 0, 0);
    top: 44%;
    left: 55%;
    width: 18%;
    height: 18%;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #ffffff;
  }

  .green_box_app {
    position: absolute;
    background-color: green;
    top: 22%;
    left: 55%;
    width: 18%;
    height: 18%;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #ffffff;
  }

  .App-header_app {
    background-color: #6C6BAE;
    min-height: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 3.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: white;
  }

  .body_left_head_app {
    /* position: absolute;
    top: 0%;
    left: 0%; #F3F7F9 */
    background-color: #F3F7F9;
    width: 100%;
    height:1vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 3.2vw;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #2F343B;
  }

  .login_box_new {
    position: absolute;
    background-color: rgb(255, 255, 255);
    top: 90%;
    left: 40%;
    width: 15vw;
    height: 5vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 1.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: #2F343B;
  }

.footer_app {
  background-color: #2F343B;
  height: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.4vh;
  color: white;
  /* position: relative; */
}
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB;4BAC0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE;;aAEW;EACX,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,kBAAkB;EAC3C,uBAAuB,EAAE,mBAAmB;EAC5C,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,kBAAkB;EAC3C,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,kBAAkB;EAC3C,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,kBAAkB;EAC3C,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;EACd,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,0DAA0D;EAC9E,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,yBAAyB;IACzB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,kBAAkB;IAC3C,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,cAAc;IACd,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,kBAAkB;IAC3C,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,kBAAkB;IAC3C,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,kBAAkB;IAC3C,2BAA2B,EAAE,mBAAmB;IAChD,gBAAgB;IAChB,iCAAiC;IACjC,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE;;uBAEmB;IACnB,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,cAAc;EAChB;;AAEF;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;AACA","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header_app {\n  background-color: #6C6BAE;\n  min-height: 13vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.8vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: white;\n}\n\n.body_app {\n  background-color: #000000;\n  height: 75vh;\n  display: flex;\n  flex-direction: row;\n  /* align-items: center;\n  justify-content: center; */\n  color: white;\n}\n\n.body_left_app {\n  position: relative;\n  background-color: #ffffff;\n  min-width: 50vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n}\n\n.logo_box_app {\n  position: absolute;\n  top: 10%;\n  left: 0%;\n  background-color: #ffffff;\n  width: 50%;\n  height: 60%;\n}\n\n.body_left_head_app {\n  /* position: absolute;\n  top: 0%;\n  left: 0%; */\n  background-color: #F3F7F9;\n  min-width: 50vw;\n  min-height:6vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.body_left_right_app {\n  position: absolute;\n  background-color: #ffffff;\n  top: 10%;\n  left: 50%;\n  width: 50%;\n  height: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  padding-left: 5%;\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.Available_box {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  top: 22%;\n  left: 5%;\n  width: 10vw;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.Unvailable_box {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  top: 44%;\n  left: 5%;\n  width: 10vw;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.Time_box {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  top: 68%;\n  left: 5%;\n  width: 20vw;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  font-size: 1vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: lighter;\n  color: #2F343B;\n}\n\n/* .login_box {\n  position: absolute;\n  background-color: #ffffff;\n  top: 75%;\n  left: 40%;\n  width: 20%;\n  height: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n  border: 0.1vw solid #646464;\n  border-radius: 2vw;\n} */\n\n.login_box_new {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  top: 93%;\n  left: 40%;\n  width: 10vw;\n  height: 5vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 1vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.red_box {\n  position: absolute;\n  background-color: rgb(255, 0, 0);\n  top: 44%;\n  left: 55%;\n  width: 18%;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n.green_box_app {\n  position: absolute;\n  background-color: green;\n  top: 22%;\n  left: 55%;\n  width: 18%;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n.body_right {\n  position: relative; /* เมื่อกล่องใช้ absulote จะอ้างอิงตำแหน่งจาก div นี้แทน */\n  background-color: #80e588;\n  min-width: 50vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2vw;\n  color: white;\n}\n\n.footer_app {\n  background-color: #2F343B;\n  height: 12vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 1vw;\n  color: white;\n}\n\n.box_row_1_1 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_1_2 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_1_3 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_1_4 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_2_1 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_2_2 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_2_3 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_2_4 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_3_1 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_3_2 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_3_3 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_3_4 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_4_1 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 40%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_4_2 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 46%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_4_3 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 52%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_4_4 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 58%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.box_row_4_5 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 64%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nhtml, body {\n  overflow-x: hidden;\n  width: 100%;\n  max-width: 100vw;\n}\n\n@media (max-width: 768px) {\n  .body_app {\n    background-color: #000000;\n    flex-grow: 1;\n    height: auto !important;\n    /* min-height: vh; */\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  .body_left_app {\n    width: 100% ;\n    height: 40vh ;\n    /* min-height: 45vh ; */\n    position: relative;\n  }\n\n  .body_right {\n    width: 100% ;\n    height: 50vh ;\n    /* min-height: 40vh ; */\n    position: relative;\n  }\n\n  .logo_box_app {\n    position: absolute;\n    top: 13%;\n    left: 0%;\n    background-color: #ffffff;\n    width: 50%;\n    height: 80%;\n  }\n\n  .body_left_right_app {\n    position: absolute;\n    background-color: #ffffff;\n    top: 13%;\n    left: 50%;\n    width: 50vw;\n    height: 35vh;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    padding-left: 5%;\n    font-size: 2vw;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #2F343B;\n  }\n\n  .Available_box {\n    position: absolute;\n    background-color: rgb(255, 255, 255);\n    top: 22%;\n    left: 5%;\n    width: 10vw;\n    height: 18%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #2F343B;\n  }\n\n  .Unvailable_box {\n    position: absolute;\n    background-color: rgb(255, 255, 255);\n    top: 44%;\n    left: 5%;\n    width: 10vw;\n    height: 18%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #2F343B;\n  }\n\n  .Time_box {\n    position: absolute;\n    background-color: rgb(255, 255, 255);\n    top: 68%;\n    left: 5%;\n    width: 30vh;\n    height: 18%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* ตำแหน่งแนวนอน */\n    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n    font-size: 1.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: lighter;\n    color: #2F343B;\n  }\n\n  .red_box {\n    position: absolute;\n    background-color: rgb(255, 0, 0);\n    top: 44%;\n    left: 55%;\n    width: 18%;\n    height: 18%;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #ffffff;\n  }\n\n  .green_box_app {\n    position: absolute;\n    background-color: green;\n    top: 22%;\n    left: 55%;\n    width: 18%;\n    height: 18%;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #ffffff;\n  }\n\n  .App-header_app {\n    background-color: #6C6BAE;\n    min-height: 10vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: white;\n  }\n\n  .body_left_head_app {\n    /* position: absolute;\n    top: 0%;\n    left: 0%; #F3F7F9 */\n    background-color: #F3F7F9;\n    width: 100%;\n    height:1vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 3.2vw;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #2F343B;\n  }\n\n  .login_box_new {\n    position: absolute;\n    background-color: rgb(255, 255, 255);\n    top: 90%;\n    left: 40%;\n    width: 15vw;\n    height: 5vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 1.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: #2F343B;\n  }\n\n.footer_app {\n  background-color: #2F343B;\n  height: 12vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4vh;\n  color: white;\n  /* position: relative; */\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
